export default __webpack_public_path__ + "static/media/foto2@3x.10d45b9c.png";